const state = {
  userInfo: {},
  shakePopupClose: true,
  version: ''
}

export default state



// WEBPACK FOOTER //
// ./src/starcharge/store/state.js